import { render, staticRenderFns } from "./FileBroadcast.vue?vue&type=template&id=a87cefc0&scoped=true&"
import script from "./FileBroadcast.vue?vue&type=script&lang=js&"
export * from "./FileBroadcast.vue?vue&type=script&lang=js&"
import style0 from "./FileBroadcast.vue?vue&type=style&index=0&id=a87cefc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87cefc0",
  null
  
)

export default component.exports